import {ReportServiceEvents} from "./report_service_events";
import {ILoginService} from "../oe/login-service";
import {ITokenService} from "../token-service";
import {_F} from "../../utility/func";
import isMapPage = _F.isMapPage;

export interface IReportService {
    reportTemplateByName(name: string) : ng.IPromise<object>;
    getReport(id: string) : ng.IPromise<object>;
    createReport(subject: any, reportTemplateId: string, title:string, topicName?: string) : ng.IPromise<object>;
    createReportForName(subject: any, reportName: string, title:string, topicName?: string) : ng.IPromise<object>;
    reportsForUserFeatureId(id: string|number): object[];
    deleteReport(report: any): ng.IPromise<any>;
    updateReport(report: any);
}

export enum ReportTemplateIds {
    AREA_REPORT= '9db0ea6b-a660-46c8-9e66-b6ff77eb2b22',
    POINT_REPORT = '81b80dfc-e52e-4878-aeb2-7329bde82b3d'
}

export class ReportService implements IReportService {
    public static $inject = ['$http', '$q', '$location', '$rootScope', 'loginService', 'tokenService'];
    constructor(protected $http: ng.IHttpService,
                protected $q: ng.IQService,
                protected $location: ng.ILocationService,
                protected $rootScope: ng.IRootScopeService,
                protected loginService: ILoginService,
                protected tokenService: ITokenService) {

        const init = () => {
            if (!window['LTConfiguration']) {
                // don't try to load the reports if we aren't on the map page
                return; // TODO - a better solution for this hack
            }
            let reportsRequest = this.getReports();
            reportsRequest.then((reports) => {
                reports.forEach((rp: any) => {
                    if (!rp) return;
                    // let subject = rp.subject;
                    const sid = rp.subjectId;
                    if (!sid) return;
                    this.featureReports[sid] = this.featureReports[sid] || [];
                    this.featureReports[sid].push(rp);
                    this.userFeatureIdFromReportId[rp.id] = sid;
                });
            });
        };

        if (isMapPage()) init();

        this.$rootScope.$on('loginService:success', (ev, currentMember: number, previousMember: number) => {
            if (currentMember == previousMember) {
                return;
            }

            if (currentMember) {
                if (previousMember) {
                    this.userFeatureIdFromReportId = {};
                    this.featureReports = {};
                }
                init();
            }
        });
    }

    protected userFeatureIdFromReportId : { [reportId: string] : string} = {};

    protected featureReports : { [userFeatureId: string] : object[]} = {};

    public serverUrl: string = '/reportApi';

    public updateReport(report: any) {
        let id = report && report.id;
        if (!id) return;

        let subject = report && report.subject;
        let subjectId = subject && subject.id;
        if (!subjectId) return;

        const currentReport = this.featureReports[subjectId].filter(rp => rp['id'] === id)[0];

        this.$rootScope.$broadcast(ReportServiceEvents.reportChanged, report, currentReport);

        this.featureReports[subjectId] = (this.featureReports[subjectId] || []).filter(rp => rp['id'] !== id).concat([report]);
        this.userFeatureIdFromReportId[id] = subjectId;
    }

    public reportsForUserFeatureId(id: string|number) {
        return id ? this.featureReports[''+id] : [];
    }

    public reportTemplateByName(name: string) : ng.IPromise<object> {
        return this.$http.get<object>(`${this.serverUrl}/api/v1/reportTemplate/byname/${name}`)
            .then(resp => resp.data);
    }

    public reportTemplateTopicByName(reportTplName: string, topicName: string) : ng.IPromise<object> {
        return this.$http.get<object>(`${this.serverUrl}/api/v1/reportTemplate/byname/${reportTplName}/topic/${topicName}`)
            .then(resp => resp.data);
    }

    protected _reports: ng.IPromise<{id: string, title:string}[]> = null;

    protected noReports: ng.IPromise<{id: string, title: string}[]> = this.$q.resolve([]);

    public getReports(): ng.IPromise<object[]> {
        if (window['fragDisabled']) {
            return this.$q.resolve([]);
        }

        const memberId = this.loginService.currentMemberId();
        if (!memberId) {
            return this.noReports;
        }

        return this._reports || this.tokenService.getTokenBody().then((tokenBody) => {
            const iss = tokenBody.iss.replace(/"/g, '\\\"');
            return this.$http.post(`${this.serverUrl}/graphql`, {
                query: `query {
  allReports (condition: {
    memberId: ${tokenBody.memberId},
    site: "${iss}"
  }) {
    nodes {
      id,
      title,
      subjectId
    }
  }
}`}).then(response => (<any> response.data).data.allReports.nodes);
        })
    }

    public getReport(id: string) : ng.IPromise<object> {
        return this.$http.get(`${this.serverUrl}/api/v1/report/${id}`);
    }

    public createReport(subject: any, reportTemplateId: string, title: string, topicId: string = null) : ng.IPromise<object> {
        let topics = {};
        if (topicId) topics[topicId] = {};

        let result = this.$http.post<object>(`${this.serverUrl}/api/v1/report/`, {
            title,
            subject,
            topics,
            reportTemplateId
        }).then(resp => resp.data);


        result.then((rp: any) => {
            let rid = rp.id;
            let sid = subject.id;

            this.featureReports[sid] = this.featureReports[sid] || [];
            this.featureReports[sid].push(rp);
            this.userFeatureIdFromReportId[rid] = sid;
        });

        return result;
    }

    createReportForName(subject: any, reportName: string, title:string, topicName: string = null): ng.IPromise<object> {
        let topicsRequest = topicName ? this.reportTemplateTopicByName(reportName, topicName)
            .then((topic) => {
                return topic['id'];
            }, () => {
                return null;
            }) : this.$q.resolve(null);

        return this.reportTemplateByName(reportName).then((rpTpl: any) => {
            if (!rpTpl || !rpTpl.id) this.$q.reject(`reportTemplate ${name} not found`);
            return topicsRequest.then((topicId) => this.createReport(subject, rpTpl.id, title,topicId || undefined));
        });
    }

    deleteReport(report: any): ng.IPromise<any> {
        if (report && report.id) {
            return this.$http.delete(`${this.serverUrl}/api/v1/report/${report.id}`)
                .then(() => {
                    let ufId = this.userFeatureIdFromReportId[report.id];
                    if (ufId) {
                        this.featureReports[ufId] = this.featureReports[ufId].filter((rp) => rp['id'] !== report.id);
                        delete this.userFeatureIdFromReportId[report.id];
                    }
                    this.$rootScope.$broadcast(ReportServiceEvents.reportDeleted, report);
                });
        }
        return this.$q.reject('invalid report parameter');
    }
}
